// @ts-nocheck

import React, { useEffect, useState, useRef } from 'react';
import { alpha } from '@mui/material/styles';
import Avatar from '@mui/material/Avatar';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import IconButton from '@mui/material/IconButton';
import FeedbackIcon from '@mui/icons-material/Feedback';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Rating from '@mui/material/Rating';
import { ThemeProvider } from '@mui/material/styles';
import MenuIcon from '@mui/icons-material/Menu';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import { Box, Select, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import i18n from '../i18n';
import useActiveOrganisation from '../collaboration/useActiveOrganisation';
import theme from '../resources/NodeTheme';

import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import HomeIcon from '@mui/icons-material/Home';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import DescriptionIcon from '@mui/icons-material/Description';
import TaskOutlinedIcon from '@mui/icons-material/TaskOutlined';
import TaskIcon from '@mui/icons-material/Task';
import PeopleIcon from '@mui/icons-material/People';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import AccountBalanceOutlinedIcon from '@mui/icons-material/AccountBalanceOutlined';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import AssessmentIcon from '@mui/icons-material/Assessment';
import TimelineIcon from '@mui/icons-material/Timeline';
import MapIcon from '@mui/icons-material/Map';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import HistoryIcon from '@mui/icons-material/History';
import SettingsIcon from '@mui/icons-material/Settings';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import InfoIcon from '@mui/icons-material/Info';
import ArticleIcon from '@mui/icons-material/Article';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';
import FolderIcon from '@mui/icons-material/Folder';
import FolderOutlinedIcon from '@mui/icons-material/FolderOutlined';

import { fetchUser } from '../collaboration/useYDoc';
import { useNavigate } from 'react-router-dom';

import useActiveUser from '../collaboration/useActiveUser';

export enum CurrentPages {
  Home = 'home',
  Tasks = 'tasks',
  Settings = 'settings',
  Documents = 'documents',
  Files = 'files',
  Instructions = 'instructions',
  Description = 'description',
  BankAccounts = 'bankaccounts',
}

export type CurrentPage =
  | CurrentPages.Home
  | CurrentPages.Tasks
  | CurrentPages.Settings
  | CurrentPages.Documents
  | CurrentPages.Files
  | CurrentPages.Instructions
  | CurrentPages.Description
  | CurrentPages.BankAccounts;

export enum CurrentPageLabels {
  Home = 'Home',
  Tasks = 'Tasks',
  Settings = 'Settings',
  Documents = 'Activity',
  Files = 'Files',
  Instructions = 'Instructions',
  Description = 'Description',
  BankAccounts = 'Bank Accounts',
}

export type CurrentPageLabel =
  | CurrentPageLabels.Home
  | CurrentPageLabels.Tasks
  | CurrentPageLabels.Settings
  | CurrentPageLabels.Documents
  | CurrentPageLabels.Files
  | CurrentPageLabels.Instructions
  | CurrentPageLabels.Description
  | CurrentPageLabels.BankAccounts;

const headerBarStyle = {
  display: 'flex',
  alignItems: 'center',
  padding: '0.75rem 1rem',
  borderBottom: `0.1rem solid ${theme.palette.primary.main}`,
  userSelect: 'none',
  gap: '2rem',
  backgroundColor: '#FFFFFF',
  position: 'sticky',
  top: 0,
  zIndex: 1100,
  transition: 'box-shadow 0.3s ease',
  height: '84.5px',
  boxSizing: 'border-box',
};

const flonessTitleStyle = {
  fontFamily: 'Inter',
  fontWeight: 500,
  fontSize: '1.5rem',
  margin: '0',
  pointerEvents: 'none',
  color: theme.palette.primary.main,
  '@media (max-width: 710px)': {
    margin: '0 auto',
  },
};

const headerLinksStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: '1.5rem',
  flexGrow: 1,
  fontFamily: 'Inter',
  whiteSpace: 'nowrap',
  justifyContent: 'flex-start',
  '@media (max-width: 710px)': {
    display: 'none',
  },
};

const headerLinkStyle = {
  margin: 0,
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  justifyContent: 'center',
  cursor: 'pointer',
  padding: '6px',
  color: alpha(theme.palette.primary.main, 0.7),
  transition: 'color 0.2s ease',
  '& .MuiSvgIcon-root': {
    fontSize: '24px',
    marginBottom: '2px',
  },
};

const headerLinkHoverStyle = {
  color: theme.palette.primary.main,
};

const headerLinkTextStyle = {
  fontSize: '0.875rem',
  fontWeight: 500,
  margin: 0,
  display: 'none',
  '@media (min-width: 1400px)': {
    display: 'block',
  },
};

const headerLinkCurrentStyle = {
  color: theme.palette.primary.main,
  fontWeight: 600,
};

const headerProfilePictureStyle = {
  marginRight: '0.5rem',
  cursor: 'pointer',
  border: '0.25rem solid transparent',
  width: '40px',
  height: '40px',
};

const headerProfilePictureHoverStyle = {
  border: `0.25rem solid ${alpha(theme.palette.primary.main, 0.2)}`,
};

const selectStyle = {
  display: 'none',
  '@media (min-width: 1170px)': {
    display: 'block',
  },
};

const menuItemStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
};

const feedbackButtonStyle = {
  marginRight: '16px',
  display: 'none',
  '@media (min-width: 1170px)': {
    display: 'inline-flex',
  },
};

const languageSelectStyle = {
  width: '150px',
  display: 'none',
  '@media (min-width: 1170px)': {
    display: 'block',
  },
};

const organizationSelectStyle = {
  ...selectStyle,
};

const sidebarButtonStyle = {
  display: 'none',
  '@media screen and (max-width: 1169px)': {
    display: 'flex',
  },
};

const drawerStyle = {
  '& .MuiDrawer-paper': {
    width: 312,
    padding: '1rem',
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
    borderTopRightRadius: { xs: 0, sm: 16 },
    borderBottomRightRadius: { xs: 0, sm: 16 },
    maxHeight: '100vh',
    overflowY: 'auto',
    boxSizing: 'border-box',
  },
  '& .MuiListItem-root': {
    borderRadius: '8px',
    marginBottom: '8px',
    '&:last-child': {
      marginBottom: 0,
    },
    '&.Mui-selected': {
      backgroundColor: 'rgba(56, 39, 103, 0.08)',
    },
  },
  '& .MuiListItemIcon-root': {
    minWidth: '40px',
  },
  '& .MuiListItemText-root': {
    margin: 0,
  },
};

const drawerLogoStyle = {
  fontFamily: 'Inter',
  fontWeight: 400,
  fontSize: '1.5rem',
  marginBottom: '1rem',
  textAlign: 'center',
};

const HeaderBar = (props: {
  currentPage: CurrentPage;
  setCurrentPage:
    | React.Dispatch<React.SetStateAction<CurrentPage>>
    | ((page: CurrentPage) => void);
}) => {
  const [pfpSrc, setPfpSrc] = useState<string | undefined>(undefined);
  const [profileMenuOpen, setProfileMenuOpen] = useState<boolean>(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  const { t } = useTranslation();

  const avatarRef = useRef(null);

  const navigate = useNavigate();

  const { activeUser } = useActiveUser();

  const [availableOrganisations, setAvailableOrganisations] = useState<
    string[]
  >([]);

  useEffect(() => {
    const fetchOrganisations = async () => {
      const response = await fetch('/api/organizations');
      setAvailableOrganisations(await response.json());
    };

    fetchOrganisations();
  }, [setAvailableOrganisations]);

  const [newOrganizationName, setNewOrganizationName] = useState<string>('');

  const createNewOrganisation = async (newOrganizationName) => {
    const response = await fetch('/api/organizations', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ organizationName: newOrganizationName }),
    });

    const newOrganisation = await response.json();

    setAvailableOrganisations([...availableOrganisations, newOrganisation]);
  };

  useEffect(() => {
    setPfpSrc(activeUser.picture);
  }, []);

  const [activeOrganisation, setActiveOrganisation] = useActiveOrganisation();

  const [feedbackDialogOpen, setFeedbackDialogOpen] = useState(false);
  const [feedbackTopic, setFeedbackTopic] = useState('');
  const [feedbackContent, setFeedbackContent] = useState('');
  const [feedbackRating, setFeedbackRating] = useState<number | null>(null);

  const handleFeedbackSubmit = () => {
    // Here you would typically send the feedback to your backend
    console.log({ feedbackTopic, feedbackContent, feedbackRating });
    setFeedbackDialogOpen(false);
    // Reset the form
    setFeedbackTopic('');
    setFeedbackContent('');
    setFeedbackRating(null);
  };

  const isFlonessUser = false && activeUser.email?.endsWith('@floness.com');

  const handleLanguageChange = (lang: string) => {
    i18n.changeLanguage(lang);
    localStorage.setItem('userLanguage', lang);
  };

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <Box sx={{
        ...headerBarStyle,
        width: '100%',
        boxShadow: isScrolled ? '0 2px 3px rgba(0,0,0,0.2)' : 'none',
      }}>
        <IconButton
          onClick={() => setSidebarOpen(true)}
          sx={sidebarButtonStyle}
          title={t('Open Menu')}
        >
          <MenuIcon />
        </IconButton>
        
        <Typography variant="h1" sx={flonessTitleStyle}>Floness</Typography>
        
        <Box sx={headerLinksStyle}>
          <Box
            component="p"
            className={`headerLink${props.currentPage === CurrentPages.Home ? ' current' : ''}`}
            title={t(CurrentPageLabels.Home)}
            onClick={() => navigate('/dashboard')}
            sx={{
              ...headerLinkStyle,
              ...(props.currentPage === CurrentPages.Home ? headerLinkCurrentStyle : {}),
              '&:hover': headerLinkHoverStyle
            }}
          >
            {props.currentPage === CurrentPages.Home ? (
              <HomeIcon
                sx={{
                  fontSize: { xs: '20px', '@media (min-width: 1170px)': '24px' },
                  mb: { xs: 0.25, '@media (min-width: 1170px)': 0.5 },
                }}
              />
            ) : (
              <HomeOutlinedIcon
                sx={{
                  fontSize: { xs: '20px', '@media (min-width: 1170px)': '24px' },
                  mb: { xs: 0.25, '@media (min-width: 1170px)': 0.5 },
                }}
              />
            )}
            <Typography component="span" sx={headerLinkTextStyle}>
              {t(CurrentPageLabels.Home)}
            </Typography>
          </Box>

          <Box
            component="p"
            className={`headerLink${props.currentPage === CurrentPages.Documents ? ' current' : ''}`}
            title={t(CurrentPageLabels.Documents)}
            onClick={() => navigate('/activity')}
            sx={{
              ...headerLinkStyle,
              ...(props.currentPage === CurrentPages.Documents ? headerLinkCurrentStyle : {}),
              '&:hover': headerLinkHoverStyle
            }}
          >
            {props.currentPage === CurrentPages.Documents ? (
              <DescriptionIcon
                sx={{
                  fontSize: '24px',
                  mb: 0.5,
                }}
              />
            ) : (
              <DescriptionOutlinedIcon
                sx={{
                  fontSize: '24px',
                  mb: 0.5,
                }}
              />
            )}
            <Typography component="span" sx={headerLinkTextStyle}>
              {t(CurrentPageLabels.Documents)}
            </Typography>
          </Box>

          <Box
            component="p"
            className={`headerLink${props.currentPage === CurrentPages.Files ? ' current' : ''}`}
            title={t(CurrentPageLabels.Files)}
            onClick={() => navigate('/files')}
            sx={{
              ...headerLinkStyle,
              ...(props.currentPage === CurrentPages.Files ? headerLinkCurrentStyle : {}),
              '&:hover': headerLinkHoverStyle
            }}
          >
            {props.currentPage === CurrentPages.Files ? (
              <InsertDriveFileIcon
                sx={{
                  fontSize: '24px',
                  mb: 0.5,
                }}
              />
            ) : (
              <InsertDriveFileOutlinedIcon
                sx={{
                  fontSize: '24px',
                  mb: 0.5,
                }}
              />
            )}
            <Typography component="span" sx={headerLinkTextStyle}>
              {t(CurrentPageLabels.Files)}
            </Typography>
          </Box>

          <Box
            component="p"
            className={`headerLink${props.currentPage === CurrentPages.Tasks ? ' current' : ''}`}
            title={t(CurrentPageLabels.Tasks)}
            onClick={() => navigate('/tasks')}
            sx={{
              ...headerLinkStyle,
              ...(props.currentPage === CurrentPages.Tasks ? headerLinkCurrentStyle : {}),
              '&:hover': headerLinkHoverStyle
            }}
          >
            {props.currentPage === CurrentPages.Tasks ? (
              <TaskIcon
                sx={{
                  fontSize: '24px',
                  mb: 0.5,
                }}
              />
            ) : (
              <TaskOutlinedIcon
                sx={{
                  fontSize: '24px',
                  mb: 0.5,
                }}
              />
            )}
            <Typography component="span" sx={headerLinkTextStyle}>
              {t(CurrentPageLabels.Tasks)}
            </Typography>
          </Box>

          <Box
            component="p"
            className={`headerLink${props.currentPage === CurrentPages.Description ? ' current' : ''}`}
            title={t(CurrentPageLabels.Description)}
            onClick={() => navigate('/description')}
            sx={{
              ...headerLinkStyle,
              ...(props.currentPage === CurrentPages.Description ? headerLinkCurrentStyle : {}),
              '&:hover': headerLinkHoverStyle
            }}
          >
            {props.currentPage === CurrentPages.Description ? (
              <ArticleIcon
                sx={{
                  fontSize: '24px',
                  mb: 0.5,
                }}
              />
            ) : (
              <ArticleOutlinedIcon
                sx={{
                  fontSize: '24px',
                  mb: 0.5,
                }}
              />
            )}
            <Typography component="span" sx={headerLinkTextStyle}>
              {t(CurrentPageLabels.Description)}
            </Typography>
          </Box>

          <Box
            component="p"
            className={`headerLink${props.currentPage === CurrentPages.Instructions ? ' current' : ''}`}
            title={t(CurrentPageLabels.Instructions)}
            onClick={() => navigate('/instructions')}
            sx={{
              ...headerLinkStyle,
              ...(props.currentPage === CurrentPages.Instructions ? headerLinkCurrentStyle : {}),
              '&:hover': headerLinkHoverStyle
            }}
          >
            {props.currentPage === CurrentPages.Instructions ? (
              <InfoIcon
                sx={{
                  fontSize: '24px',
                  mb: 0.5,
                }}
              />
            ) : (
              <InfoOutlinedIcon
                sx={{
                  fontSize: '24px',
                  mb: 0.5,
                }}
              />
            )}
            <Typography component="span" sx={headerLinkTextStyle}>
              {t(CurrentPageLabels.Instructions)}
            </Typography>
          </Box>

          <Box
            component="p"
            className={`headerLink${props.currentPage === CurrentPages.BankAccounts ? ' current' : ''}`}
            title={t(CurrentPageLabels.BankAccounts)}
            onClick={() => navigate('/bank-accounts')}
            sx={{
              ...headerLinkStyle,
              ...(props.currentPage === CurrentPages.BankAccounts ? headerLinkCurrentStyle : {}),
              '&:hover': headerLinkHoverStyle
            }}
          >
            {props.currentPage === CurrentPages.BankAccounts ? (
              <AccountBalanceIcon
                sx={{
                  fontSize: '24px',
                  mb: 0.5,
                }}
              />
            ) : (
              <AccountBalanceOutlinedIcon
                sx={{
                  fontSize: '24px',
                  mb: 0.5,
                }}
              />
            )}
            <Typography component="span" sx={headerLinkTextStyle}>
              {t(CurrentPageLabels.BankAccounts)}
            </Typography>
          </Box>

          <Box
            component="p"
            className={`headerLink${props.currentPage === CurrentPages.Settings ? ' current' : ''}`}
            title={t('Settings')}
            onClick={() => navigate('/settings')}
            sx={{
              ...headerLinkStyle,
              ...(props.currentPage === CurrentPages.Settings ? headerLinkCurrentStyle : {}),
              '&:hover': headerLinkHoverStyle
            }}
          >
            {props.currentPage === CurrentPages.Settings ? (
              <SettingsIcon
                sx={{
                  fontSize: { xs: '20px', '@media (min-width: 1170px)': '24px' },
                  mb: { xs: 0.25, '@media (min-width: 1170px)': 0.5 },
                }}
              />
            ) : (
              <SettingsOutlinedIcon
                sx={{
                  fontSize: { xs: '20px', '@media (min-width: 1170px)': '24px' },
                  mb: { xs: 0.25, '@media (min-width: 1170px)': 0.5 },
                }}
              />
            )}
            <Typography component="span" sx={headerLinkTextStyle}>
              {t('Settings')}
            </Typography>
          </Box>
        </Box>

        <Drawer
          anchor="left"
          open={sidebarOpen}
          onClose={() => setSidebarOpen(false)}
          sx={drawerStyle}
        >
          <List>
            {/* Show navigation links in sidebar under 650px */}
            <Box sx={{ 
              '@media (min-width: 710px)': {
                display: 'none',
              },
              '@media (max-width: 709px)': {
                display: 'block',
              },
            }}>
              <ListItem
                button
                onClick={() => {
                  navigate('/dashboard');
                  setSidebarOpen(false);
                }}
                selected={props.currentPage === CurrentPages.Home}
              >
                <ListItemIcon>
                  {props.currentPage === CurrentPages.Home ? (
                    <HomeIcon />
                  ) : (
                    <HomeOutlinedIcon />
                  )}
                </ListItemIcon>
                <ListItemText primary={t(CurrentPageLabels.Home)} />
              </ListItem>

              <ListItem
                button
                onClick={() => {
                  navigate('/activity');
                  setSidebarOpen(false);
                }}
                selected={props.currentPage === CurrentPages.Documents}
              >
                <ListItemIcon>
                  {props.currentPage === CurrentPages.Documents ? (
                    <DescriptionIcon />
                  ) : (
                    <DescriptionOutlinedIcon />
                  )}
                </ListItemIcon>
                <ListItemText primary={t(CurrentPageLabels.Documents)} />
              </ListItem>

              <ListItem
                button
                onClick={() => {
                  navigate('/files');
                  setSidebarOpen(false);
                }}
                selected={props.currentPage === CurrentPages.Files}
              >
                <ListItemIcon>
                  {props.currentPage === CurrentPages.Files ? (
                    <InsertDriveFileIcon />
                  ) : (
                    <InsertDriveFileOutlinedIcon />
                  )}
                </ListItemIcon>
                <ListItemText primary={t(CurrentPageLabels.Files)} />
              </ListItem>

              <ListItem
                button
                onClick={() => {
                  navigate('/tasks');
                  setSidebarOpen(false);
                }}
                selected={props.currentPage === CurrentPages.Tasks}
              >
                <ListItemIcon>
                  {props.currentPage === CurrentPages.Tasks ? (
                    <TaskIcon />
                  ) : (
                    <TaskOutlinedIcon />
                  )}
                </ListItemIcon>
                <ListItemText primary={t(CurrentPageLabels.Tasks)} />
              </ListItem>

              <ListItem
                button
                onClick={() => {
                  navigate('/description');
                  setSidebarOpen(false);
                }}
                selected={props.currentPage === CurrentPages.Description}
              >
                <ListItemIcon>
                  {props.currentPage === CurrentPages.Description ? (
                    <ArticleIcon />
                  ) : (
                    <ArticleOutlinedIcon />
                  )}
                </ListItemIcon>
                <ListItemText primary={t(CurrentPageLabels.Description)} />
              </ListItem>

              <ListItem
                button
                onClick={() => {
                  navigate('/instructions');
                  setSidebarOpen(false);
                }}
                selected={props.currentPage === CurrentPages.Instructions}
              >
                <ListItemIcon>
                  {props.currentPage === CurrentPages.Instructions ? (
                    <InfoIcon />
                  ) : (
                    <InfoOutlinedIcon />
                  )}
                </ListItemIcon>
                <ListItemText primary={t(CurrentPageLabels.Instructions)} />
              </ListItem>

              <ListItem
                button
                onClick={() => {
                  navigate('/bank-accounts');
                  setSidebarOpen(false);
                }}
                selected={props.currentPage === CurrentPages.BankAccounts}
              >
                <ListItemIcon>
                  {props.currentPage === CurrentPages.BankAccounts ? (
                    <AccountBalanceIcon />
                  ) : (
                    <AccountBalanceOutlinedIcon />
                  )}
                </ListItemIcon>
                <ListItemText primary={t(CurrentPageLabels.BankAccounts)} />
              </ListItem>

              <ListItem
                button
                onClick={() => {
                  navigate('/settings');
                  setSidebarOpen(false);
                }}
                selected={props.currentPage === CurrentPages.Settings}
              >
                <ListItemIcon>
                  {props.currentPage === CurrentPages.Settings ? (
                    <SettingsIcon />
                  ) : (
                    <SettingsOutlinedIcon />
                  )}
                </ListItemIcon>
                <ListItemText primary={t('Settings')} />
              </ListItem>

              <Divider sx={{ my: 2 }} />
            </Box>

            <ListItem>
              <Select
                value={activeOrganisation?.organizationId}
                sx={{ width: '100%' }}
              >
                <MenuItem
                  value={activeUser.id}
                  onClick={() => {
                    setActiveOrganisation({
                      organizationId: activeUser.id,
                      organizationName: `Personal account for ${activeUser.name}`,
                    });
                  }}
                  sx={menuItemStyle}
                >
                  {`Personal account for ${activeUser.name}`}
                </MenuItem>
                {availableOrganisations.map((organisation) => (
                  <MenuItem
                    key={organisation.organizationId}
                    onClick={() => {
                      setActiveOrganisation(organisation);
                    }}
                    value={organisation.organizationId}
                    sx={menuItemStyle}
                  >
                    {organisation.organizationName || 'Unnamed organisation'}
                  </MenuItem>
                ))}
                <TextField
                  sx={{ width: 'calc(100% - 2rem)', margin: '1rem' }}
                  value={newOrganizationName}
                  onChange={(event) => {
                    setNewOrganizationName(event.target.value);
                  }}
                  placeholder={'New organisation name'}
                  inputProps={{
                    onClick: (event) => event.stopPropagation(),
                    onKeyDown: (event) => {
                      event.stopPropagation();
                      if (event.keyCode == 13) {
                        setNewOrganizationName('');
                        createNewOrganisation(newOrganizationName);
                      }
                    },
                  }}
                  onClick={(event) => event.stopPropagation()}
                />
              </Select>
            </ListItem>

            <ListItem>
              <Select
                value={i18n.language}
                onChange={(event) => handleLanguageChange(event.target.value)}
                sx={{ width: '100%' }}
              >
                <MenuItem value="fi" sx={menuItemStyle}>
                  {t('Suomi')}
                </MenuItem>
                <MenuItem value="en" sx={menuItemStyle}>
                  {t('English')}
                </MenuItem>
              </Select>
            </ListItem>

            <ListItem>
              <Button
                onClick={() => {
                  setSidebarOpen(false);
                  setFeedbackDialogOpen(true);
                }}
                startIcon={<FeedbackIcon />}
                fullWidth
                variant="outlined"
              >
                {t('Provide Feedback')}
              </Button>
            </ListItem>
          </List>
        </Drawer>

        <Select
          value={activeOrganisation?.organizationId}
          sx={{
            width: '240px',
            display: 'none',
            '@media (min-width: 1170px)': {
              display: 'inline-flex',
            },
          }}
        >
          <MenuItem
            value={activeUser.id}
            onClick={() => {
              setActiveOrganisation({
                organizationId: activeUser.id,
                organizationName: `Personal account for ${activeUser.name}`,
              });
            }}
            sx={menuItemStyle}
          >
            {`Personal account for ${activeUser.name}`}
          </MenuItem>
          {availableOrganisations.map((organisation) => (
            <MenuItem
              key={organisation.organizationId}
              onClick={() => {
                setActiveOrganisation(organisation);
              }}
              value={organisation.organizationId}
              sx={menuItemStyle}
            >
              {organisation.organizationName || 'Unnamed organisation'}
            </MenuItem>
          ))}
          <TextField
            sx={{ width: 'calc(100% - 2rem)', margin: '1rem' }}
            value={newOrganizationName}
            onChange={(event) => {
              setNewOrganizationName(event.target.value);
            }}
            placeholder={'New organisation name'}
            inputProps={{
              onClick: (event) => event.stopPropagation(),
              onKeyDown: (event) => {
                event.stopPropagation();
                if (event.keyCode == 13) {
                  setNewOrganizationName('');
                  createNewOrganisation(newOrganizationName);
                }
              },
            }}
            onClick={(event) => event.stopPropagation()}
          />
        </Select>

        <Select
          value={i18n.language}
          onChange={(event) => handleLanguageChange(event.target.value)}
          sx={languageSelectStyle}
        >
          <MenuItem value="fi" sx={menuItemStyle}>
            {t('Suomi')}
          </MenuItem>
          <MenuItem value="en" sx={menuItemStyle}>
            {t('English')}
          </MenuItem>
        </Select>

        <IconButton
          onClick={() => setFeedbackDialogOpen(true)}
          sx={feedbackButtonStyle}
          title={t('Provide Feedback')}
        >
          <FeedbackIcon />
        </IconButton>

        <Avatar
          sx={headerProfilePictureStyle}
          src={pfpSrc}
          ref={avatarRef}
          onClick={() => setProfileMenuOpen(true)}
          onMouseOver={(e) =>
            (e.currentTarget.style.border = headerProfilePictureHoverStyle.border)
          }
          onMouseOut={(e) =>
            (e.currentTarget.style.border = headerProfilePictureStyle.border)
          }
        />
        
        <Dialog
          open={feedbackDialogOpen}
          onClose={() => setFeedbackDialogOpen(false)}
          aria-labelledby="feedback-dialog-title"
          sx={{
            '& .MuiDialog-paper': {
              backgroundColor: '#F8F8FB',
            },
          }}
        >
          <DialogTitle id="feedback-dialog-title">
            {t('Provide Feedback')}
          </DialogTitle>
          <DialogContent>
            <TextField
              autoFocus
              margin="dense"
              id="feedback-topic"
              label={t('Topic')}
              type="text"
              fullWidth
              variant="outlined"
              value={feedbackTopic}
              onChange={(e) => setFeedbackTopic(e.target.value)}
            />
            <TextField
              margin="dense"
              id="feedback-content"
              label={t('Feedback')}
              multiline
              rows={4}
              fullWidth
              variant="outlined"
              value={feedbackContent}
              onChange={(e) => setFeedbackContent(e.target.value)}
            />
            <Box sx={{ display: 'flex', alignItems: 'center', mt: 2 }}>
              <Typography component="legend">{t('Rating')}</Typography>
              <Rating
                name="feedback-rating"
                value={feedbackRating}
                onChange={(event, newValue) => {
                  setFeedbackRating(newValue);
                }}
              />
            </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setFeedbackDialogOpen(false)}>
              {t('Cancel')}
            </Button>
            <Button
              onClick={() => {
                fetch('/api/feedback', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'x-organization': activeOrganisation?.organizationId,
                    'x-user-uid': activeUser.id,
                  },
                  body: JSON.stringify({
                    topic: feedbackTopic,
                    content: feedbackContent,
                    rating: feedbackRating,
                  }),
                })
                  .then(() => {
                    setFeedbackDialogOpen(false);
                    setFeedbackTopic('');
                    setFeedbackContent('');
                    setFeedbackRating(null);
                  })
                  .catch((error) => {
                    console.error('Error submitting feedback:', error);
                  });
              }}
            >
              {t('Submit')}
            </Button>
          </DialogActions>
        </Dialog>

        <Menu
          open={profileMenuOpen}
          anchorEl={avatarRef.current}
          onClose={() => setProfileMenuOpen(false)}
        >
          <Typography variant="body2" sx={{ margin: '1rem' }}>
            {activeUser.name}
          </Typography>
          <Typography variant="body2" sx={{ margin: '1rem' }}>
            {activeUser.id}
          </Typography>
          <MenuItem
            onClick={() => {
              window.location.href = '/logout';
            }}
          >
            {t('Sign out')}
          </MenuItem>
        </Menu>
      </Box>
    </ThemeProvider>
  );
};

export default HeaderBar;